import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

function Ourservice() {
  const [service, setService] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const getservice = () => {
    axios
      .get("https://mindcoadmin.v4masters.com/public/index.php/getservice", { timeout: 10000 }) // 10 sec timeout
      .then((response) => {
        setService(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching service data:", error.message);
        setError("Failed to load services. Please try again later.");
        setLoading(false);
      });
  };

  useEffect(() => {
    getservice();
  }, []);

  return (
    <>
      <section className="section2" id="our-service">
        <div className="our-service-section container">
          <div className="bg-black">
            <div className="d-flex">
              <div className="left-side">
                <h2 className="fw-semi-bold">Our Service</h2>
                <p className="fw-medium">
                  Curious about how we can revitalize your brand?
                </p>
                <div className="letsdive">
                  Let's dive into your project and utilize the following IT tools
                  to hit your target and establish your business as a lasting brand!
                </div>
                <div className="d-flex">
                  <NavLink
                    to={"/service"}
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "instant" })
                    }
                    className="btn btn-black text-white border-white"
                  >
                    Read More
                  </NavLink>
                </div>
              </div>
              <div className="right-side">
                <div className="needservice">
                  <p>Need our Service?</p>
                  <div className="d-flex">
                    <a
                      href="https://wa.me/+919896570012"
                      className="btn btn-purple whatsapp-btn text-white"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 24 24"
                        fill="#44C052"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-brand-whatsapp"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
                        <path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />
                      </svg>
                      <p className="wats">Discuss a Project</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Loading and Error States */}
            {loading ? (
              <div className="text-white text-center py-4">Loading services...</div>
            ) : error ? (
              <div className="text-danger text-center py-4">{error}</div>
            ) : (
              <div className="grid-container">
                {service.map((item, index) => (
                  <NavLink
                    to={`/service/${item?.page_id}`}
                    onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                    style={{ borderRadius: "20px" }}
                    key={index}
                  >
                    <div className="grid-item">
                      <div className="card h-100">
                        <div className="card-body">
                          <img
                            className="image2"
                            src={`https://smarto.s3.ap-south-1.amazonaws.com/mindcode/service/${item.image2}`}
                            alt="our service"
                          />
                          <img
                            className="image1"
                            src={`https://smarto.s3.ap-south-1.amazonaws.com/mindcode/service/${item.image1}`}
                            alt="our service"
                          />
                          <h5 className="mt-4">
                            {item.service_title}
                            <br />
                            {item.service_title2}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Ourservice;
